import React, { useState } from "react";
import {
  Box,
  Text,
  Flex,
  Image,
  Button,
  Divider,
  useDisclosure,
  RangeSlider,
  RangeSliderTrack,
  RangeSliderThumb,
  RangeSliderFilledTrack,
  Checkbox,
} from "@chakra-ui/react";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import FormikInput from "components/formikInput";
import ShipmentSummaryModal from "./ShipmentSummaryModal";
import FormikSelect from "components/formikSelect";
import FormikTextArea from "components/formikTextArea";
import { useShipmentForm } from "context/DHLShipmentFormContext";
import { FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import FormikCheckbox from "components/formikCheckbox";
import TextInput from "./components/TextInput";
import SearchAbleSelectInput from "./components/SearchAbleSelectInput";
import { countryCodes } from "./data/countryCodes";

const LabelPrintingOptions = () => {
  // const [value, setValue] = useState("");
  const navigate = useNavigate();
  const minTime = 570; // 9:30 AM
  const maxTime = 1110; // 6:30 PM
  const { formData, updateFormData } = useShipmentForm();
  const [isEdit, setIsEdit] = useState(false);
  const [timeRange, setTimeRange] = useState([minTime, maxTime]);
  const {
    isOpen: isSummaryModalOpen,
    onOpen: onSummaryModalOpen,
    onClose: onSummaryModalClose,
  } = useDisclosure();

  const formatTimeTo24Hour = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const displayHrs = String(hrs).padStart(2, "0");
    const displayMins = String(mins).padStart(2, "0");
    return `${displayHrs}:${displayMins}`;
  };

  const formatTime = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const ampm = hrs >= 12 ? "pm" : "am";
    const displayHrs = hrs % 12 === 0 ? 12 : hrs % 12;
    const displayMins = mins < 10 ? `0${mins}` : mins;
    return `${displayHrs}:${displayMins}${ampm}`;
  };

  const validationSchema = Yup.object({
    requestType: Yup.string()
      .required("Request type is required")
      .min(3, "Must be at least 3 characters"),

    description: Yup.string()
      .required("Description is required")
      .max(300, "Maximum 300 characters allowed"),
  });

  const initialValues = {
    dateAndTime: "",
    closeTime: "18:30",
    details: {
      detailType: "",
      weight: 0,
      instruction: "",
    },
  };

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          justifyContent={"space-between"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          {/* <Box> */}
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />
          <Box>
            <Formik
              initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={(values) => {
                updateFormData({ pickup: values });
                onSummaryModalOpen();
                // navigate("/send-a-bag/dhl/package-details");
              }}
            >
              {(formik) => (
                <Form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    height: "100%",
                  }}
                >
                  <Flex flexDirection={"column"} gap={6}>
                    <Box>
                      <Text
                        color={"#000000"}
                        fontFamily="PlusJakartaSansSemiBold"
                        fontSize={"16px"}
                        lineHeight={"22px"}
                        textTransform={"capitalize"}
                        mb={2}
                      >
                        I’m sending my shipment on
                      </Text>
                      <Box
                        border="1px solid #D9D9D9"
                        borderRadius="8px"
                        p={4}
                        gap={2}
                        display={"flex"}
                        flexDirection={"column"}
                      >
                        <FormikInput
                          formik={formik}
                          name="dateAndTime"
                          placeholder={"Enter Date"}
                          label={"Date"}
                          type={"date"}
                          labelColor={"#000000"}
                        />
                        {/* <Button
                          onClick={() => {}}
                          w={"74px"}
                          h={"40px"}
                          py={6}
                          bg={"#D9D9D9"}
                          borderRadius={"4px"}
                          color={"#444444"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          fontSize={"12px"}
                          fontFamily={"PlusJakartaSansRegular"}
                        >
                          <Image
                            src={require("assets/svgs/edit.svg").default}
                            width={"16px"}
                            height={"16px"}
                            pos={"relative"}
                            mr={2}
                            _hover={{
                              cursor: "pointer",
                            }}
                          />
                          Edit
                        </Button> */}
                      </Box>
                    </Box>
                    <Box>
                      <Text
                        color={"#000000"}
                        fontFamily="PlusJakartaSansSemiBold"
                        fontSize={"16px"}
                        lineHeight={"22px"}
                        textTransform={"capitalize"}
                        mb={2}
                      >
                        Shipment Details
                      </Text>
                      <Box
                        border="1px solid #D9D9D9"
                        borderRadius="8px"
                        p={4}
                        gap={4}
                        display={"flex"}
                        flexDirection={"column"}
                      >
                        <FormikSelect
                          formik={formik}
                          name="details.detailType"
                          label={
                            "Where should the courier pick up the shipment?"
                          }
                          placeholder={"Select one"}
                        >
                          <option value="residence">Residence</option>
                          <option value="back-door">Back Door</option>
                          <option value="front-door">Front Door</option>
                          <option value="loading-bay">Loading Bay</option>
                          <option value="other">other</option>
                        </FormikSelect>
                        <FormikInput
                          formik={formik}
                          name="details.weight"
                          label={"Total pickup weight"}
                          placeholder={"Enter weight"}
                          type={"number"}
                          labelColor={"#000000"}
                          unit={"kg"}
                        />
                        <FormikTextArea
                          formik={formik}
                          name="details.instruction"
                          label={"Instructions for the courier"}
                          placeholder={"Provide other instructions"}
                        />
                      </Box>
                    </Box>
                    <Box>
                      <Flex gap={2}>
                        <Text
                          color={"#000000"}
                          fontFamily="PlusJakartaSansSemiBold"
                          fontSize={"16px"}
                          lineHeight={"22px"}
                          textTransform={"capitalize"}
                          mb={2}
                        >
                          Pickup window
                        </Text>
                        <Image
                          src={require("assets/svgs/info-circle.svg").default}
                          width={"22px"}
                          height={"22px"}
                          pos={"relative"}
                          _hover={{
                            cursor: "pointer",
                          }}
                        />
                      </Flex>
                      <Flex flexDir={"column"} gap={4}>
                        <Box
                          border="1px solid #FFC700"
                          borderRadius="8px"
                          p={3}
                          gap={1}
                          bg={"#FFC7001A"}
                          display={"flex"}
                          alignItems={"center"}
                        >
                          <Text
                            color={"#FFC700"}
                            fontFamily="PlusJakartaSansSemiBold"
                            fontSize={"10px"}
                            lineHeight={"14px"}
                          >
                            Note
                          </Text>
                          <Text
                            color={"#444444"}
                            fontFamily="PlusJakartaSansRegular"
                            fontSize={"10px"}
                            lineHeight={"14px"}
                          >
                            - Pickup cannot be scheduled for your shipment date.
                            Schedule for the next available date. Please be
                            advised that Saturday pickups incur a minimum charge
                            of £18.
                          </Text>
                        </Box>
                        <Box
                          border="1px solid #D9D9D9"
                          borderRadius="8px"
                          p={6}
                          gap={6}
                          display={"flex"}
                          flexDirection={"column"}
                        >
                          <Flex align="center" gap={8}>
                            <Flex flexDir={"column"}>
                              <Text
                                color={"#000000"}
                                fontFamily="PlusJakartaSansMedium"
                                fontSize={"12px"}
                                lineHeight={"16px"}
                                textAlign={"center"}
                              >
                                Earliest
                              </Text>
                              <Text
                                color={"#000000"}
                                fontFamily="PlusJakartaSansBold"
                                fontSize={"12px"}
                                lineHeight={"16px"}
                                textAlign={"center"}
                              >
                                {formatTime(timeRange[0])}
                              </Text>
                            </Flex>

                            <RangeSlider
                              flex={1}
                              min={minTime}
                              max={maxTime}
                              step={30}
                              defaultValue={[minTime, maxTime]}
                              onChangeEnd={(values) => {
                                setTimeRange(values);
                                const dateOnly =
                                  formik?.values?.dateAndTime?.split("T")[0]; // Get only YYYY-MM-DD
                                const totalMinutes = values[0];

                                const hours = Math.floor(totalMinutes / 60);
                                const minutes = totalMinutes % 60;

                                const dateTimeString = `${dateOnly}T${String(
                                  hours
                                ).padStart(2, "0")}:${String(minutes).padStart(
                                  2,
                                  "0"
                                )}:00.000Z`;

                                formik.setFieldValue(
                                  "dateAndTime",
                                  dateTimeString
                                );
                                formik.setFieldValue(
                                  "closeTime",
                                  formatTimeTo24Hour(values[1])
                                );
                              }}
                            >
                              <RangeSliderTrack>
                                <RangeSliderFilledTrack bg="black" />
                              </RangeSliderTrack>
                              <RangeSliderThumb index={0} />
                              <RangeSliderThumb index={1} />
                            </RangeSlider>
                            <Flex flexDir={"column"}>
                              <Text
                                color={"#000000"}
                                fontFamily="PlusJakartaSansMedium"
                                fontSize={"12px"}
                                lineHeight={"16px"}
                                textAlign={"center"}
                              >
                                Latest
                              </Text>
                              <Text
                                color={"#000000"}
                                fontFamily="PlusJakartaSansBold"
                                fontSize={"12px"}
                                lineHeight={"16px"}
                                textAlign={"center"}
                              >
                                {formatTime(timeRange[1])}
                              </Text>
                            </Flex>
                          </Flex>
                          <Text
                            color={"#898989"}
                            fontFamily="PlusJakartaSansRegular"
                            fontSize={"12px"}
                            lineHeight={"16px"}
                            textAlign={"center"}
                          >
                            Please allow at least 120 minutes for your Pickup
                            Window
                          </Text>
                        </Box>
                      </Flex>
                    </Box>
                    <Box>
                      <Flex alignItems={"center"}>
                        <Text
                          fontFamily={"PlusJakartaSansSemiBold"}
                          fontSize={"16px"}
                          textTransform={"capitalize"}
                          color={"#000000"}
                          flex={1}
                        >
                          Pickup Address
                        </Text>
                        <Flex alignSelf={"flex-end"} gap={2}>
                          <Button
                            onClick={() => setIsEdit(true)}
                            // w={"70px"}
                            // h={"20px"}
                            py={6}
                            bg={"#D9D9D9"}
                            borderRadius={"4px"}
                            color={"#444444"}
                            alignItems={"center"}
                            justifyContent={"center"}
                            fontSize={"12px"}
                            fontFamily={"PlusJakartaSansRegular"}
                          >
                            <Image
                              src={require("assets/svgs/edit.svg").default}
                              width={"16px"}
                              height={"16px"}
                              pos={"relative"}
                              mr={2}
                              _hover={{
                                cursor: "pointer",
                              }}
                            />
                            Edit
                          </Button>
                          {/* <Button
                            onClick={() => {}}
                            // w={"183px"}
                            // h={"20px"}
                            py={6}
                            bg={"#D9D9D9"}
                            borderRadius={"4px"}
                            color={"#444444"}
                            alignItems={"center"}
                            justifyContent={"center"}
                            fontSize={"12px"}
                            fontFamily={"PlusJakartaSansRegular"}
                          >
                            Make my default pickup address
                          </Button> */}
                        </Flex>
                      </Flex>
                      {isEdit ? (
                        <Formik
                          initialValues={formData.details} // or nested fields
                          onSubmit={(values) => {
                            // Update only the 'details' section of formData
                            updateFormData({
                              details: values,
                            });

                            setIsEdit(false);
                          }}
                        >
                          {(formik) => (
                            <Form>
                              <Flex
                                gap={4}
                                marginTop={2}
                                borderWidth={"1px"}
                                borderColor={"#D9D9D9"}
                                borderStyle={"solid"}
                                padding={4}
                                borderRadius={"6px"}
                                flexDirection={"column"}
                              >
                                <Flex gap={4}>
                                  <TextInput
                                    formik={formik}
                                    name="from.contact.name"
                                    label="Name"
                                    placeholder="Enter Name"
                                  />
                                  <TextInput
                                    formik={formik}
                                    name="from.contact.companyName"
                                    label={"Company Name"}
                                    placeholder="Enter Company Name"
                                  />
                                </Flex>
                                <Flex gap={1} alignItems={"center"}>
                                  <FormikCheckbox
                                    id="from.contact.businessContact"
                                    name="from.contact.businessContact"
                                    isChecked={
                                      formik.values.from.contact.businessContact
                                    }
                                    onChange={formik.handleChange}
                                  />
                                  <Text
                                    fontFamily={"PlusJakartaSansMedium"}
                                    fontSize={"12px"}
                                    textTransform={"capitalize"}
                                    color={"#000000"}
                                    mb={1}
                                  >
                                    Business Contact
                                  </Text>
                                </Flex>
                                <Flex gap={4}>
                                  <SearchAbleSelectInput
                                    name="from.address.country"
                                    label={"Country"}
                                    placeholder={"United Kingdom"}
                                    onChangeHandler={(value) => {
                                      // setSelectFromCountry({
                                      //   label: value?.label,
                                      //   value: value?.value?.code,
                                      // });
                                      // setSelectFromCountryCode({
                                      //   label: value?.value?.phoneCode,
                                      //   value: value?.value?.phoneCode,
                                      // });
                                      // formik.setFieldValue(
                                      //   "from.address.country",
                                      //   value?.value?.code
                                      // );
                                      // formik.setFieldValue(
                                      //   `from.contact.phone[${0}].code`,
                                      //   value?.value?.phoneCode
                                      // );
                                    }}
                                    // selectedValue={selectFromCountry}
                                    disabled
                                  >
                                    {countryCodes.map((opt) => (
                                      <option key={opt.code} value={opt}>
                                        {opt.name}
                                      </option>
                                    ))}
                                  </SearchAbleSelectInput>
                                  <TextInput
                                    formik={formik}
                                    name="from.contact.email"
                                    label={"Email Address"}
                                    placeholder={"Enter Email Address"}
                                  />
                                </Flex>
                                <Flex gap={4}>
                                  <TextInput
                                    formik={formik}
                                    name="from.address.address.one"
                                    label={"Address 1"}
                                    placeholder={"Enter Address 1"}
                                  />
                                </Flex>
                                <Flex gap={4}>
                                  <TextInput
                                    formik={formik}
                                    name="from.address.address.two"
                                    label={"Address 2"}
                                    placeholder={"Enter Address 2"}
                                  />
                                  {/* <TextInput
                                    formik={formik}
                                    name="from.address.address.three"
                                    label={"Address 3"}
                                    placeholder={"Enter Address 3"}
                                  /> */}
                                </Flex>
                                <Flex gap={4}>
                                  <TextInput
                                    formik={formik}
                                    name="from.address.postalCode"
                                    label={"Postal Code"}
                                    placeholder={"Enter Postal Code"}
                                  />
                                  <TextInput
                                    formik={formik}
                                    name="from.address.city"
                                    label={"City"}
                                    placeholder={"Enter City"}
                                  />
                                </Flex>
                                <Flex gap={1} alignItems={"center"}>
                                  <FormikCheckbox
                                    id="from.address.residentialAddress"
                                    name="from.address.residentialAddress"
                                    isChecked={
                                      formik.values.from.address
                                        .residentialAddress
                                    }
                                    onChange={formik.handleChange}
                                  />
                                  <Text
                                    fontFamily={"PlusJakartaSansMedium"}
                                    fontSize={"12px"}
                                    textTransform={"capitalize"}
                                    color={"#000000"}
                                    mb={1}
                                  >
                                    Residential Address
                                  </Text>
                                </Flex>
                                <FieldArray name="from.contact.phone">
                                  {({ push, remove }) => (
                                    <>
                                      {formik.values.from.contact.phone.map(
                                        (_, index) => (
                                          <Flex key={index} gap={4} mb={2}>
                                            {/* <TextInput
                                        formik={formik}
                                        name={`from.contact.phone[${index}].type`}
                                        label={"Phone Type"}
                                        placeholder={"Enter Phone Type"}
                                      /> */}
                                            <FormikSelect
                                              formik={formik}
                                              name={`from.contact.phone[${index}].type`}
                                              label={"Phone Type"}
                                            >
                                              <option value="mobile">
                                                Mobile
                                              </option>
                                            </FormikSelect>
                                            {/* <TextInput
                                        formik={formik}
                                        name={`from.contact.phone[${index}].code`}
                                        label={"Code"}
                                        placeholder={"+44"}
                                      /> */}
                                            <SearchAbleSelectInput
                                              name={`from.contact.phone[${index}].code`}
                                              label={"Code"}
                                              placeholder={"GB"}
                                              // onChangeHandler={(value) => {
                                              //   setSelectFromCountryCode(value);
                                              //   formik.setFieldValue(
                                              //     `from.contact.phone[${index}].code`,
                                              //     value?.value
                                              //   );
                                              // }}
                                              // selectedValue={
                                              //   selectFromCountryCode
                                              // }
                                              disabled
                                            >
                                              {countryCodes.map((opt) => (
                                                <option
                                                  key={opt.phoneCode}
                                                  value={opt.phoneCode}
                                                >
                                                  {opt.phoneCode}
                                                </option>
                                              ))}
                                            </SearchAbleSelectInput>
                                            <TextInput
                                              formik={formik}
                                              name={`from.contact.phone[${index}].number`}
                                              label={"Phone"}
                                              placeholder={"0751 5360049"}
                                            />
                                            {index > 0 && (
                                              <Button
                                                onClick={() => remove(index)}
                                                w={"100px"}
                                                h={"30px"}
                                                py={5}
                                                bg={"#FF5252"}
                                                borderRadius={"4px"}
                                                _hover={"none"}
                                                alignSelf={"flex-end"}
                                                alignItems={"center"}
                                                justifyContent={"center"}
                                              >
                                                <Image
                                                  src={
                                                    require("assets/svgs/cross.svg")
                                                      .default
                                                  }
                                                  width={"22px"}
                                                  height={"22px"}
                                                  stroke={"#ffffff"}
                                                  pos={"relative"}
                                                  _hover={{
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </Button>
                                            )}
                                          </Flex>
                                        )
                                      )}

                                      {/* <Flex gap={1} alignItems={"center"} mb={4}>
                                  <FormikCheckbox
                                    id="smsEnabled"
                                    name="from.contact.smsEnabled"
                                    isChecked={
                                      formik.values.from.contact.smsEnabled
                                    }
                                    onChange={formik.handleChange}
                                  />
                                  <Text
                                    fontFamily={"PlusJakartaSansMedium"}
                                    fontSize={"12px"}
                                    textTransform={"capitalize"}
                                    color={"#000000"}
                                  >
                                    SMS Enabled
                                  </Text>
                                </Flex> */}

                                      <Flex gap={4}>
                                        <Button
                                          onClick={() =>
                                            push({
                                              type: "",
                                              code: "",
                                              number: "",
                                            })
                                          }
                                          w={"120px"}
                                          h={"40px"}
                                          py={6}
                                          bg={"#D9D9D9"}
                                          borderRadius={"4px"}
                                          color={"#444444"}
                                          alignSelf={"flex-end"}
                                          alignItems={"center"}
                                          justifyContent={"center"}
                                          fontSize={"12px"}
                                          fontFamily={"PlusJakartaSansRegular"}
                                        >
                                          <Image
                                            src={
                                              require("assets/svgs/plus_dark.svg")
                                                .default
                                            }
                                            width={"16px"}
                                            height={"16px"}
                                            pos={"relative"}
                                            mr={2}
                                            _hover={{
                                              cursor: "pointer",
                                            }}
                                          />
                                          Add another
                                        </Button>
                                      </Flex>
                                    </>
                                  )}
                                </FieldArray>
                                <Flex alignSelf={"flex-end"} gap={2}>
                                  <Button
                                    onClick={() => setIsEdit(false)}
                                    py={2}
                                    bg={"#D9D9D9"}
                                    borderRadius={"4px"}
                                    color={"#444444"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    fontSize={"12px"}
                                    fontFamily={"PlusJakartaSansRegular"}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    onClick={() => formik.handleSubmit()}
                                    py={2}
                                    bg={"#D9D9D9"}
                                    borderRadius={"4px"}
                                    color={"#444444"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    fontSize={"12px"}
                                    fontFamily={"PlusJakartaSansRegular"}
                                  >
                                    Save
                                  </Button>
                                </Flex>
                              </Flex>
                            </Form>
                          )}
                        </Formik>
                      ) : (
                        <Flex
                          gap={2}
                          marginTop={2}
                          borderWidth={"1px"}
                          borderColor={"#D9D9D9"}
                          borderStyle={"solid"}
                          padding={4}
                          borderRadius={"6px"}
                          flexDirection={"column"}
                        >
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Name:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData?.details?.from?.contact?.name}
                            </Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Company:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData?.details?.from?.contact?.companyName ||
                                "N/A"}
                            </Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Country:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData?.details?.from?.address?.country ===
                              "GB"
                                ? "United Kingdom"
                                : "N/A"}
                            </Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Address 1:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData.details.from.address.address.one}
                            </Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Address 2:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData?.details?.from?.address?.address?.two}
                            </Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Postal Code:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData?.details?.from?.address?.postalCode ||
                                "N/A"}
                            </Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Email Address:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData?.details?.from?.contact?.email}
                            </Text>
                          </Flex>
                          <Flex gap={2}>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              textTransform={"capitalize"}
                              color={"#898989"}
                              width={"100px"}
                            >
                              Phone:
                            </Text>
                            <Text
                              fontFamily={"PlusJakartaSansMedium"}
                              fontSize={"12px"}
                              lineHeight={"16px"}
                              color={"#000000"}
                            >
                              {formData?.details?.from?.contact?.phone?.map(
                                (phone, index) => (
                                  <span key={index}>
                                    {phone.code} {phone.number}
                                    {index <
                                      formData?.details?.from?.contact?.phone
                                        .length -
                                        1 && ", "}
                                  </span>
                                )
                              ) || "N/A"}
                            </Text>
                          </Flex>
                        </Flex>
                      )}
                    </Box>
                    <Flex mt={4} gap={2} flex={1} alignItems={"flex-end"}>
                      <Flex>
                        <Button
                          onClick={() => navigate(-1)}
                          width={"148px"}
                          borderRadius={8}
                          bg={"none"}
                          border={"1px solid #000000"}
                          color={"#000000"}
                          fontSize={"12px"}
                          fontWeight={"500"}
                          fontFamily={"PlusJakartaSansMedium"}
                          letterSpacing={0.2}
                        >
                          Back
                        </Button>
                      </Flex>
                      <Flex
                        justifyContent={"flex-end"}
                        flex={1}
                        w={"100%"}
                        gap={2}
                      >
                        <Button
                          onClick={() => formik.handleSubmit()}
                          flex={1}
                          maxW={"148px"}
                          background={"#000000"}
                          color={"#FFFFFF"}
                          borderRadius={8}
                          fontSize={"12px"}
                          fontFamily={"PlusJakartaSansMedium"}
                          textTransform={"uppercase"}
                          // isDisabled={}
                          // _disabled={{
                          //   bg: "grey.100",
                          //   cursor: "default",
                          //   _hover: {
                          //     bg: "grey.100",
                          //     cursor: "default",
                          //   },
                          // }}
                        >
                          Next
                        </Button>
                      </Flex>
                    </Flex>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Box>
          {/* <Flex
            alignSelf={"flex-end"}
            alignItems={"flex-end"}
            justifyContent={"flex-end"}
            flex={1}
            bottom={0}
            w={"100%"}
            gap={2}
            mt={4}
          >
            <Button
              onClick={() => {
                onSummaryModalOpen();
              }}
              flex={1}
              maxW={"148px"}
              background={"#000000"}
              color={"#FFFFFF"}
              borderRadius={8}
              fontSize={"12px"}
              fontFamily={"PlusJakartaSansMedium"}
              textTransform={"uppercase"}
              // isDisabled={}
              _disabled={{
                bg: "grey.100",
                cursor: "default",
                _hover: {
                  bg: "grey.100",
                  cursor: "default",
                },
              }}
            >
              Next
            </Button>
          </Flex> */}
        </Flex>
      </Flex>
      <ShipmentSummaryModal
        isOpen={isSummaryModalOpen}
        onClose={onSummaryModalClose}
      />
    </MainLayout>
  );
};

export default LabelPrintingOptions;
